module.exports = __webpack_public_path__ + "img/1.b21f5d41.png";